import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, IconButton } from "@mui/material";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { DRAWER_TYPES } from "../../Constantes/drawers";
import { CloseIcon } from "../../Components/Icons/Miscellaneous/CloseIcon";
import { useMobile } from "../../Hooks/useMobile";
import { useDesktop } from "../../Hooks/useDesktop";
import { LoginForm } from "../../Forms/LoginForm/LoginForm";
import logoIcon from "../../Recursos/genesis_logo_icon.webp";
import logoFull from "../../Recursos/genesis_logo_full.webp";
import character_2_desktop from "../../Recursos/character_2_desktop.webp";
import character_2_mobile_tablet from "../../Recursos/character_2_mobile_tablet.webp";
import { useNavigate } from "react-router-dom";
import { RUTAS } from "rutas";
import { paramService } from "Services/param_service";
import { useQuery } from "Hooks/useQuery";
import "./LoginDrawer.scss";

export const LoginDrawer = () => {
  const [loading, setLoading] = useState(false);
  const { data: images } = useQuery(paramService.param, {
    grupo: "imagenes",
    files: true,
  });

  const getUrlValue = (codigo) => {
    return (
      images?.data?.find((item) => item.codigoParametro === codigo)?.url || "#"
    );
  };

  const logoTabletUp = getUrlValue("logo_genesis") || logoFull;
  const logoMobile = getUrlValue("logo_mobile") || logoIcon;

  const dispatch = useDispatch();
  const activeDrawer = useSelector((state) => state.ui.activeDrawer);
  const isOpen = activeDrawer === DRAWER_TYPES.LOGIN;
  const navigate = useNavigate();

  const isMobile = useMobile();
  const logoSrc = isMobile ? logoMobile : logoTabletUp;
  const isDesktop = useDesktop();
  const characterSrc = isDesktop
    ? character_2_desktop
    : character_2_mobile_tablet;

  const handleClose = () => {
    if (loading) return;
    dispatch(setActiveDrawer(null));
  };

  const handleClickRegister = () => {
    dispatch(setActiveDrawer(DRAWER_TYPES.REGISTER));
  };

  const handleLogoClick = () => {
    if (loading) return;
    navigate(RUTAS.PRINCIPAL);
    dispatch(setActiveDrawer(null));
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={loading ? null : handleClose}
      className="login-drawer"
      PaperProps={{
        className: "login-drawer__paper",
      }}
    >
      <div className="login-drawer__container">
        <div className="login-drawer__header">
          <div className="login-drawer__logo" onClick={handleLogoClick}>
            <img
              src={logoSrc}
              alt="Genesis Logo"
              onError={(e) => {
                e.target.src = isMobile ? logoIcon : logoFull;
              }}
            />
          </div>
          <IconButton
            onClick={handleClose}
            aria-label="Cerrar"
            disabled={loading}
          >
            <CloseIcon width={32} height={30} className="text-azul-7" />
          </IconButton>
        </div>
        <div className="login-drawer__cintillo" />
        <div className="login-drawer__body">
          <div className="login-drawer__content">
            <h2 className="login-drawer__title-mobile heading-l-bold mb-0">
              ¡Hola, bienvenido de vuelta!
            </h2>

            <div className="login-drawer__image">
              <img
                src={characterSrc}
                alt="Genesis Character"
                className="login-drawer__character"
              />
            </div>

            <div className="login-drawer__form-section">
              <h2 className="login-drawer__title-tablet-desktop">
                ¡Hola, bienvenido de vuelta!
              </h2>

              <LoginForm loading={loading} setLoading={setLoading} />

              <div className="login-drawer__separator">
                <div className="login-drawer__separator-line"></div>
                <span className="login-drawer__separator-text">o</span>
                <div className="login-drawer__separator-line"></div>
              </div>

              <span className="login-drawer__register-link">
                <p className="paragraph-m-medium">¿Aún no tienes una cuenta?</p>
                <p
                  className="paragraph-m-bold text-cian"
                  onClick={handleClickRegister}
                >
                  Regístrate
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
